import { useContext, useEffect, useState } from 'react';

import { AppContext, formatListData } from 'commons-ui';
import { DateFilter, GetLotteryWinnerApiResponse, GetLotteryWinnerResponse } from '../../types';
import useService from './useService';

const useList = () => {
	const { showAlert } = useContext(AppContext);
	const { getLotteryWinningsListData } = useService();
	const [lotteryWinningsData, setLotteryWinningsData] = useState<GetLotteryWinnerResponse>({
		rowCount: 0,
		data: [],
		meta: {
			matches: [],
			draws: []
		}
	});
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [filters, setFilters] = useState<DateFilter>();
	const [showLoader, setShowLoader] = useState<boolean>(false);

	const fetchLotteryWinningsData = async () => {
		try {
			setShowLoader(true);
			const lotteryWinningsListData: GetLotteryWinnerApiResponse = await getLotteryWinningsListData({
				filters
			});
			if (lotteryWinningsListData?.data?.success) {
				setLotteryWinningsData({
					rowCount: lotteryWinningsListData?.rowCount,
					data: formatListData(lotteryWinningsListData?.data?.data?.data),
					meta: {
						matches: lotteryWinningsListData?.data?.data?.meta?.matches,
						draws: lotteryWinningsListData?.data?.data?.meta?.draws
					}
				});
				setForceUpdate(true);
			} else {
				setLotteryWinningsData({ data: [], rowCount: 0, meta: { matches: [], draws: [] } });
				showAlert(lotteryWinningsListData?.data?.message, { type: 'error' });
			}
		} catch (error: any) {
			setLotteryWinningsData({ data: [], rowCount: 0, meta: { matches: [], draws: [] } });
			showAlert('Error fetching lottery winnings data', { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	useEffect(() => {
		if (filters) {
			fetchLotteryWinningsData();
		}
	}, [filters]);

	const getLotteryWinningsData = () => {
		setForceUpdate(false);
		return lotteryWinningsData;
	};

	const handleFilterSubmit = (data: DateFilter) => {
		const { selectedDate } = data;
		if (selectedDate) {
			setFilters({ selectedDate });
		}
	};

	return {
		getLotteryWinningsData,
		handleFilterSubmit,
		forceUpdate,
		showLoader,
		setShowLoader,
		fetchLotteryWinningsData,
		lotteryWinningsData
	};
};

export default useList;
